const TrophicState = () => {
  const TrophicStateData = [
    {
      'Trophic State': 'Oligotrophic',
      'Total P (ug/L)': '<5',
      'Chlorophyll a (ug/L)': '<2',
      'Secchi Depth (m)': '>5.6',
      'Relative Productivity': 'Low',
    },
    {
      'Trophic State': 'Mesotrophic',
      'Total P (ug/L)': '5-30',
      'Chlorophyll a (ug/L)': '2-6',
      'Secchi Depth (m)': '2-5.6',
      'Relative Productivity': 'Moderate',
    },
    {
      'Trophic State': 'Eutrophic',
      'Total P (ug/L)': '30-100',
      'Chlorophyll a (ug/L)': '6-40',
      'Secchi Depth (m)': '0.5-2',
      'Relative Productivity': 'High',
    },
    {
      'Trophic State': 'Hypereutrophic',
      'Total P (ug/L)': '>100',
      'Chlorophyll a (ug/L)': '>40',
      'Secchi Depth (m)': '<0.5',
      'Relative Productivity': 'Excessive',
    },
    {
      'Trophic State': 'Average\nReservoir WY 2023',
      'Total P (ug/L)': 142,
      'Chlorophyll a (ug/L)': 16.2,
      'Secchi Depth (m)': 1.38,
      'Relative Productivity': 'High',
    },
  ];

  // Declare and configure request overview table
  const TrophicStateTable = new requestTable({
    container: '#trophic-state-table',
    filterEnabled: false,
    tableHeaders: {
      'Trophic State': 'Trophic State',
      'Total P (ug/L)': 'Total P (ug/L)',
      'Chlorophyll a (ug/L)': 'Chlorophyll a (ug/L)',
      'Secchi Depth (m)': 'Secchi Depth (m)',
      'Relative Productivity': 'Relative Productivity',
    },
    tableActions: [],
    tableData: TrophicStateData,
  });
  TrophicStateTable.buildTable();
};
